/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SharedReportResetPasswordInput = {|
  sharedId: string,
  clientMutationId?: ?string,
|};
export type sharedReportResetPasswordMutationVariables = {|
  input: SharedReportResetPasswordInput
|};
export type sharedReportResetPasswordMutationResponse = {|
  +sharedReportResetPassword: ?{|
    +success: ?boolean,
    +viewer: ?{|
      +id: string
    |},
  |}
|};
export type sharedReportResetPasswordMutation = {|
  variables: sharedReportResetPasswordMutationVariables,
  response: sharedReportResetPasswordMutationResponse,
|};
*/


/*
mutation sharedReportResetPasswordMutation(
  $input: SharedReportResetPasswordInput!
) {
  sharedReportResetPassword(input: $input) {
    success
    viewer {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "SharedReportResetPasswordInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SharedReportResetPasswordPayload",
    "kind": "LinkedField",
    "name": "sharedReportResetPassword",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sharedReportResetPasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sharedReportResetPasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "sharedReportResetPasswordMutation",
    "operationKind": "mutation",
    "text": "mutation sharedReportResetPasswordMutation(\n  $input: SharedReportResetPasswordInput!\n) {\n  sharedReportResetPassword(input: $input) {\n    success\n    viewer {\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '301a1dda7a53e9a0611f58e2eade3d4f';

module.exports = node;
